"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextRenderer = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Renderer_1 = require("@kyruus/rich-text/Renderer");
exports.RichTextRenderer = (0, styled_1.default)((props) => (react_1.default.createElement(Renderer_1.RichTextRenderer, Object.assign({}, props, { tagName: "div", styleReset: "revert" })))) `
  ${(_a) => {
    var { id } = _a, props = __rest(_a, ["id"]);
    return `
    &${id ? `#${id}` : ''}.${Renderer_1.STYLE_RESET_CLASSNAME} {
      padding-top: ${(0, ui_theme_1.fromTheme)('spacing_large')(props)};
      font-family: ${(0, ui_theme_1.fromTheme)('font_face')(props)};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')(props)};
      line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')(props)};
      overflow-wrap: break-word;
      overflow-x: auto;
      & section:not(:last-of-type) {
        margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')(props)};
      }
      & table {
        border-width: ${(0, ui_theme_1.fromTheme)('border_width')(props)};
        border-style: ${(0, ui_theme_1.fromTheme)('border_style')(props)};
        border-color: ${(0, ui_theme_1.fromTheme)('color_border')(props)};
        border-collapse: collapse;
        table-layout: fixed;
        min-width: 100%;
        & td,
        & th {
          border-width: ${(0, ui_theme_1.fromTheme)('border_width')(props)};
          border-style: ${(0, ui_theme_1.fromTheme)('border_style')(props)};
          border-color: ${(0, ui_theme_1.fromTheme)('color_border')(props)};
          text-align: left;
        }
      }
      & img {
        max-width: 100%;
      }
      & hr {
        border: none;
        height: 1px;
        background-color: ${(0, ui_theme_1.fromTheme)('color_border')(props)};
      }
      & p,
      & ol,
      & ul {
        margin: ${(0, ui_theme_1.fromTheme)('spacing_small')(props)} 0;
        &:first-of-type {
          margin-top: 0;
        }
      }
      & ul,
      & ol {
        margin-left: 1em;
        padding-left: 0;
        list-style-position: inside;
      }
    }
  `;
}};
`;
//# sourceMappingURL=RichTextStyleReset.styles.js.map